import React from 'react';
import type { PatientPreset } from '../types/simulation';
type SimulatorNavProps = {
  patients: PatientPreset[];
  currentIndex: number;
  onBack: () => void;
  onIntro: () => void;
  onSelectPatient: (index: number) => void;
  onReplay: () => void;
  onSkip: () => void;
};
const LINK = 'rounded-full px-3 py-1.5 text-sm text-graphite transition-colors duration-150 hover:bg-white hover:text-ink focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent';
export function SimulatorNav({
  patients,
  currentIndex,
  onBack,
  onIntro,
  onSelectPatient,
  onReplay,
  onSkip
}: SimulatorNavProps) {
  return <nav className="mb-4 flex flex-wrap items-center justify-between gap-3" aria-label="Simulator navigation" data-id="element-339" data-mp="bh7pduhsiygh">
      <div className="flex items-center gap-1" data-id="element-340" data-mp="gg2etfa9jl9k">
        <button type="button" onClick={onBack} className={LINK} data-id="element-341" data-mp="25u7au48uqmvo">
          ← Back
        </button>
        <button type="button" onClick={onIntro} className={LINK} data-id="element-342" data-mp="2ar7hag9m5rnb">
          Intro
        </button>
      </div>

      <ol className="flex items-center gap-1" aria-label="Patients" data-id="element-343" data-mp="1zg6mmjt5o73m">
        {patients.map((p, i) => {
        const current = i === currentIndex;
        return <li key={p.id} data-id="element-344" data-mp="297kimhlweos0" data-mpi={i}>
              <button type="button" onClick={() => onSelectPatient(i)} aria-current={current ? 'true' : undefined} className={`rounded-full px-3 py-1.5 font-mono text-xs tabular-nums transition-colors duration-150 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent ${current ? 'bg-ink text-white' : 'text-graphite hover:bg-white hover:text-ink'}`} data-id="element-345" data-mp="296szw7deglj5">
                PT-{p.id}
              </button>
            </li>;
      })}
      </ol>

      <div className="flex items-center gap-1" data-id="element-346" data-mp="31u5dhs1l1j0b">
        <button type="button" onClick={onReplay} className={LINK} data-id="element-347" data-mp="2wxeyl81iktgh">
          ↺ Replay case
        </button>
        <button type="button" onClick={onSkip} className={LINK} data-id="element-348" data-mp="34ycuh667yklz">
          Skip patient →
        </button>
      </div>
    </nav>;
}